import type { IconName } from '@fortawesome/fontawesome-svg-core';

export enum BottomNavigationItem {
  HOME = 'home',
  SHOP = 'shop',
  ACCOUNT = 'account',
  OFFERS = 'offers',
}

type BottomNavigationItemDisplayType = keyof typeof BottomNavigationItemType;
export enum BottomNavigationItemType {
  Image = 'Image',
  /**
   * @deprecated Future version icon option will be removed
   */
  Icon = 'Icon',
}

export interface BottomNavigationImage {
  activeImageUrl: string;
  inactiveImageUrl: string;
}

export interface BottomNavigationItemsProps {
  label: string;
  activeRoute?: string;
  url: string;
  type: BottomNavigationItemDisplayType;
  icon?: IconName;
  image?: BottomNavigationImage;
  isLoggedIn?: boolean;
}
